import { Footer } from "@c/layout/Footer";
import { HomeNavbar } from "@c/layout/HomeNavbar";
import { SkipLink } from "@c/shared/SkipLink";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if ("scrollRestoration" in history) history.scrollRestoration = "manual";
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

export default function HomeLayout() {
  return (
    <div className="relative min-h-dvh flex flex-col bg-background">
      <ScrollToTop />
      <SkipLink />
      <HomeNavbar />

      <main
        id="main-content"
        tabIndex={-1}
        className="relative flex-1 flex flex-col isolate z-10 focus:outline-none"
      >
        <Outlet />
      </main>

      <Footer />
    </div>
  );
}
